var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 96 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7657 1.72353H5.88466C3.78386 1.72353 2.08082 3.39544 2.08082 5.45784V17.5422C2.08082 19.6046 3.78385 21.2765 5.88466 21.2765H17.7657C19.8665 21.2765 21.5696 19.6046 21.5696 17.5422V5.45784C21.5696 3.39544 19.8665 1.72353 17.7657 1.72353ZM5.88466 0C2.81425 0 0.325195 2.44356 0.325195 5.45784V17.5422C0.325195 20.5564 2.81425 23 5.88466 23H17.7657C20.8361 23 23.3252 20.5564 23.3252 17.5422V5.45784C23.3252 2.44356 20.8361 0 17.7657 0H5.88466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9483 6.01371L4.52058 10.1711C4.4656 10.188 4.41749 10.2201 4.38263 10.2631C4.34778 10.3061 4.32783 10.3579 4.32544 10.4117C4.32305 10.4654 4.33833 10.5186 4.36925 10.5641C4.40018 10.6096 4.44528 10.6453 4.49856 10.6664L9.43312 12.6303C9.45898 12.6407 9.48729 12.6447 9.51531 12.6419C9.54332 12.6391 9.57008 12.6297 9.59298 12.6144L14.4305 9.40457C14.5806 9.30611 14.7649 9.47728 14.6589 9.61664L11.2022 14.1087C11.1861 14.13 11.1761 14.1547 11.1732 14.1806C11.1704 14.2065 11.1747 14.2326 11.1859 14.2564L13.3 18.8387C13.3227 18.8882 13.3611 18.9301 13.41 18.9589C13.4589 18.9877 13.5162 19.0019 13.574 18.9998C13.6319 18.9977 13.6877 18.9792 13.7341 18.9469C13.7804 18.9146 13.8151 18.87 13.8334 18.819L18.3104 6.34924C18.3273 6.3025 18.3298 6.25232 18.3176 6.20435C18.3054 6.15637 18.2791 6.11249 18.2416 6.07764C18.2041 6.04279 18.1568 6.01835 18.1051 6.00705C18.0535 5.99576 17.9986 5.99806 17.9483 6.01371Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.89caa0a28e70e3e77f4ca12f70d2460d.svg";
export { ForwardRef as ReactComponent };